import React from "react";
import "./Industries.css";

const industriesRowOne = [
  "Healthcare",
  "Hospitality",
  "Real Estate",
  "Automotive",
  "Fashion",
  "Technology",
];

const industriesRowTwo = [
  "Restaurants",
  "Luxury Brands",
  "E-Commerce",
  "Fitness",
  "Corporate",
  "Startups",
];

const industriesRowThree = [
  "Beauty",
  "Education",
  "Finance",
  "Retail",
  "Events",
  "Personal Brands",
];

function MarqueeRow({ industries, direction = "left", outline = false }) {
  const repeatedIndustries = [...industries, ...industries];

  return (
    <div className="industries-marquee">
      <div
        className={`industries-marquee-track industries-marquee-${direction} ${
          outline ? "industries-marquee-outline" : ""
        }`}
      >
        {repeatedIndustries.map((industry, index) => (
          <React.Fragment key={`${industry}-${index}`}>
            <span className="industries-marquee-item">
              {industry}
            </span>

            <span className="industries-marquee-separator">✦</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

function Industries() {
  return (
    <section className="industries-section" id="industries">


      <div className="industries-marquees">
        <MarqueeRow
          industries={industriesRowOne}
          direction="left"
        />

        <MarqueeRow
          industries={industriesRowTwo}
          direction="right"
          outline
        />

        <MarqueeRow
          industries={industriesRowThree}
          direction="left"
        />
      </div>

 
    </section>
  );
}

export default Industries;